import { GetTypeEnum } from '@app/app.enum';
import * as constants from '@app/constants';
import { CanadianFrenchlocale } from '@app/constants';
import environment from '@app/environments/environment';
import * as models from '@app/models/index';
import Injector from '@app/services';
import axios, { AxiosResponse, CancelToken } from 'axios';
import { Injectable } from 'injection-js';
import { SharedService } from './shared.service';

@Injectable()
export class ShipmentService {
	private sharedService: SharedService = Injector.get(SharedService);
	private baseUrl = environment.apiGateway.apiUrl;
	private shipmentApiUrl = '';

	constructor() {
		this.shipmentApiUrl = this.baseUrl + 'Shipment/';
	}

	/**
	 *  Get all shipment details
	 */
	public async getShipments(
		pageToken?: string,
		startDate?: Date,
		endDate?: Date,
		appId?: string,
		carrierAccountId?: string,
		trackingNumber?: string,
		cancelToken?: CancelToken
	): Promise<models.IPagedResult<models.IShipment>> {
		try {
			const res = await axios.get<models.IPagedResult<models.IShipment>>(this.shipmentApiUrl, {
				cancelToken,
				params: {
					pageToken,
					startDate: startDate.toLocaleDateString(CanadianFrenchlocale),
					endDate: endDate.toLocaleDateString(CanadianFrenchlocale),
					appId,
					carrierAccountId,
					trackingNumber,
				},
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	public async getShipmentLabel(
		shipmentId: string,
		cancelToken?: CancelToken,
		packageNumber?: number
	): Promise<models.IPostageLabel> {
		try {
			const url = this.shipmentApiUrl + shipmentId + '/Label';
			const res = await axios.get<models.IPostageLabel>(url, {
				cancelToken,
				params: {
					packageNumber,
				},
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	public async getAllLabelsOfShipment(shipmentId: string, cancelToken?: CancelToken): Promise<void> {
		try {
			const url = this.shipmentApiUrl + shipmentId + '/Label/All';
			const res = await axios.get<any>(url, {
				cancelToken,
				responseType: 'blob',
			});
			const fileName = this.sharedService.parseContentDisposition(
				res.request.getResponseHeader(constants.contentDispositionHeader)
			);
			this.sharedService.downloadFile(res.data, fileName);
		} catch (error) {
			throw error;
		}
	}

	/**
	 *  Get all shipment details
	 */
	public async getShipment(
		key?: GetTypeEnum,
		value?: string,
		packageNumber?: number,
		cancelToken?: CancelToken
	): Promise<models.IShipment> {
		try {
			const res = await axios.get<models.IShipment>(this.shipmentApiUrl, {
				cancelToken,
				params: {
					key,
					value,
					packageNumber,
				},
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 *  Export all shipment details
	 */
	public async exportShipments(
		startDate?: Date,
		endDate?: Date,
		appId?: string,
		carrierAccountId?: string,
		trackingNumber?: string,
		cancelToken?: CancelToken
	): Promise<AxiosResponse<Blob>> {
		try {
			const res = await axios.get<Blob>(this.shipmentApiUrl + 'Export', {
				cancelToken,
				responseType: 'blob',
				params: {
					startDate: startDate.toLocaleDateString(CanadianFrenchlocale),
					endDate: endDate.toLocaleDateString(CanadianFrenchlocale),
					appId,
					carrierAccountId,
					trackingNumber,
				},
			});
			return res;
		} catch (error) {
			throw error;
		}
	}

	/*
	 *  Refund a label
	 */
	public async createRefundShipment(value: string, cancelToken?: CancelToken): Promise<models.IShipment> {
		try {
			const key = 'Id';
			const refundURL = this.shipmentApiUrl + 'Refund';
			const res = await axios.post<models.IShipment>(
				refundURL,
				{ key, value },
				{
					cancelToken,
					headers: {
						TransactionId: this.sharedService.createTransactionId(),
					},
				}
			);
			return res.data;
		} catch (error) {
			throw error;
		}
	}
}



// WEBPACK FOOTER //
// ./src/services/shipment.service.ts